import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=5e4c8fe2&scoped=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"
import style0 from "./Content.vue?vue&type=style&index=0&id=5e4c8fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c8fe2",
  null
  
)

export default component.exports